import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactModal from 'react-modal';
import styles from './age-selection-modal.css';

const AgeSelectionModal = props => (
    <ReactModal
        isOpen
        className={styles.modalContent}
        overlayClassName={styles.modalOverlay}
        onRequestClose={() => { }}
    >
        <div className={styles.container}>
            <h1 className={styles.header}>Block Coding for Kids</h1>
            <div className={styles.cardContainer}>
                <div
                    className={classNames(styles.card, styles.cardYoung)}
                    onClick={() => props.onSelect('4+')}
                >
                    <div className={styles.ageText}>4+</div>
                </div>
                <div
                    className={classNames(styles.card, styles.cardOlder)}
                    onClick={() => props.onSelect('7+')}
                >
                    <div className={styles.ageText}>7+</div>
                </div>
            </div>
        </div>
    </ReactModal>
);

AgeSelectionModal.propTypes = {
    onSelect: PropTypes.func.isRequired
};

export default AgeSelectionModal;
